import { render, staticRenderFns } from "./CustomStatsUpdate.vue?vue&type=template&id=2b7100c5"
import script from "./CustomStatsUpdate.vue?vue&type=script&lang=js"
export * from "./CustomStatsUpdate.vue?vue&type=script&lang=js"
import style0 from "./CustomStatsUpdate.vue?vue&type=style&index=0&id=2b7100c5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports